module.exports = __webpack_public_path__ + "static/media/modx.9ed0f4d1.png";